import {
  customElement,
  DeesElement,
  property,
  html,
  cssManager,
  unsafeCSS,
  css,
  TemplateResult
} from '@designestate/dees-element';

import { LeleAccountNavigation } from './navigation.js';

import * as views from '../views/index.js';
import * as state from '../state/accountstate.js';

import { commitinfo } from '../00_commitinfo_data.js';


declare global {
  interface HTMLElementTagNameMap {
    'lele-accountcontent': LeleAccountContent;
  }
}

@customElement('lele-accountcontent')
export class LeleAccountContent extends DeesElement {

  constructor() {
    super();
  }

  public static styles = [
    cssManager.defaultStyles,
    css`
      :host {
        display: block;
        color: #fff;
        padding-top: 10px;
        padding-bottom: 10px;
        height: 100%;
        width: 100%;
        background: ${cssManager.bdTheme('#eeeeeb', '#000000')}
      }
      :host([hidden]) {
        display: none;
      }
      .main {
        position: absolute;
        height: 100%;
        width: 100%;
        bottom: 0px;
      }

      lele-accountnavigation {
        position: absolute;
        bottom: 0px;
        left: 0px;
        height: calc(100vh - 40px);
        width: 200px;
      }
      .viewcontainer {
        will-change: transform;
        position: absolute;
        right: 0px;
        bottom: 0px;
        width: calc(100vw - 200px);
        height: calc(100vh - 40px);
        overflow-y: scroll;
        overscroll-behavior: contain;
        transition: all 0.3s;
        opacity: 1;
      }

      .viewcontainer.changing {
        opacity: 0;
        transform: translateY(20px);
      }
    `,
  ];

  public render(): TemplateResult {
    return html`
      <style></style>
      <div class="main">
        <lele-statusbar siteText="workspace.global Account" .commitinfo=${commitinfo}></lele-statusbar>
        <lele-accountnavigation></lele-accountnavigation>
        <div class="viewcontainer">
          <!--<lele-accountview-subscription></lele-accountview-subscription>-->
        </div>
      </div>
    `;
  }

  public async firstUpdated(_changedProperties: Map<string | number | symbol, unknown>): Promise<void> {
    super.firstUpdated(_changedProperties);
    await this.domtoolsPromise;
    const viewcontainer: HTMLDivElement = this.shadowRoot.querySelector('.viewcontainer');

    // lets setup routing
    this.domtools.router.on('/', async () => {
      viewcontainer.classList.add('changing');
      await this.domtools.convenience.smartdelay.delayFor(300);
      console.log('We are at the base route');
      viewcontainer.innerHTML = ''
      viewcontainer.append(new views.BaseView());
      viewcontainer.classList.remove('changing');
      await this.domtools.convenience.smartdelay.delayFor(300);
    });

    this.domtools.router.on('/org/:orgName/billing', async () => {
      viewcontainer.classList.add('changing');
      await this.domtools.convenience.smartdelay.delayFor(300);
      console.log('We are viewing the billing page');
      viewcontainer.innerHTML = ''
      viewcontainer.append(new views.SubscriptionView());
      viewcontainer.classList.remove('changing');
      await this.domtools.convenience.smartdelay.delayFor(300);
    })

    this.domtools.router.on('/org/:orgName/paddlesetup', async (routeInfoArg) => {
      const selectedOrgSlug = routeInfoArg.params.orgName;
      console.log(selectedOrgSlug);
      viewcontainer.classList.add('changing');
      await this.domtools.convenience.smartdelay.delayFor(300);
      console.log('We are viewing the billing page');
      viewcontainer.innerHTML = ''
      viewcontainer.append(new views.PaddleSetupView());
      viewcontainer.classList.remove('changing');
      await this.domtools.convenience.smartdelay.delayFor(300);
    })

    // lets determine the start route

    if (state) {
      await state.receptionClient.typedsocketDeferred.promise;
      this.domtools.router.pushUrl('/');
    }
  }
}
